// src/pages/xray/XrayLobby/TabPhysicalPorts.js
import React from 'react';

const TabPhysicalPorts = ({
  selectedTabsPhysicalPorts,
  setSelectedTabsPhysicalPorts,
  sfpStatus,
  wanStatus,
  lanStatus,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['SFP', 'WAN', 'LAN'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsPhysicalPorts === `tabsPhysicalPorts${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={
                selectedTabsPhysicalPorts === `tabsPhysicalPorts${index + 1}`
              }
              onChange={() =>
                setSelectedTabsPhysicalPorts(`tabsPhysicalPorts${index + 1}`)
              }
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsPhysicalPorts === 'tabsPhysicalPorts1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">SFP to Fiber Adapter</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {sfpStatus || 'No SFP status available'}
            </pre>
          </div>
        )}

        {selectedTabsPhysicalPorts === 'tabsPhysicalPorts2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              Link status of WAN1 and WAN2
            </h1>
            <div className="wan-status">
              <pre className="bg-gray-100 p-4 rounded-md border">
                {Array.isArray(wanStatus)
                  ? wanStatus.join('\n')
                  : 'No WAN status available'}
              </pre>
            </div>
          </div>
        )}

        {selectedTabsPhysicalPorts === 'tabsPhysicalPorts3' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              Link status of LAN1 to LAN4
            </h1>
            <div className="lan-status">
              <pre className="bg-gray-100 p-4 rounded-md border">
                {Array.isArray(lanStatus)
                  ? lanStatus.join('\n')
                  : 'No LAN status available'}
              </pre>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TabPhysicalPorts;
